
import React from 'react';
import { FormattedMessage } from 'react-intl';

import utils from '../../utils/utilities';
import xhr from '../../utils/xhr';

import {GET} from './../../constants';

import reduxStore from './../../reduxStore';

const PAGE_SIZE = 10;

class ArticleNavigationBox extends React.Component {

    constructor(props) {
        super(props);

        // Determine current page available so we know where to pick up navigation from

        let params = Object.assign({}, this.props.fetchUrlParams);

        let verb = GET;
        if (this.props.verb) {
            verb = this.props.verb;
        }

        let pageNo = parseInt(this.props.articleIndex / PAGE_SIZE, 10);
        let fetchUrl = this.props.fetchUrl;

        // Only get pages in increments of 10
        if (verb === GET) {
            params.pageSize = PAGE_SIZE;
            params.pageNumber = pageNo;
        } else {
            fetchUrl = this.props.fetchUrl + "?pageSize=" + PAGE_SIZE + "&pageNumber=" + pageNo;
        }

        let articleListByIndex = {};
        let articleListByArticleId = {};

        this.state = {
            currentArticleIndex: this.props.articleIndex,
            currentArticleId: this.props.articleId,
            fetchUrl: fetchUrl,
            fetchCountUrl: this.props.fetchCountUrl,
            verb : verb,
            urlParams: params,
            articleCount: null,
            articleListByIndex: articleListByIndex,
            articleListByArticleId: articleListByArticleId,
            nextArticleId: null,
            previousArticleId: null,
            nextArticleIndex: null,
            previousArticleIndex: null,
            spinnerVisibility: false
        };

        this.fillGaps = this.fillGaps.bind(this);
        this.processList = this.processList.bind(this);
        this.moveToArticle = this.moveToArticle.bind(this);
        this.changeArticleId = this.changeArticleId.bind(this);
    }

    componentDidMount() {
        // FeedViewer uses internal store. Process a fixed store
        if (this.props.internalStore) {
            let list = reduxStore.getState().viewArticlePage.initialData;
            if (list.length === 0) {
                this.setState({articleCount: 1, currentArticleIndex: 0}, ()=>{this.processList(list, 0, list.length)});
            } else {
                this.setState({articleCount: list.length}, ()=>{this.processList(list, 0, list.length)});
            }
            return;
        }

        // Preview service sends a count but not countURL, this noo need for the count call
        if (!this.state.fetchCountUrl) {
            if (this.props.articleCount) {
                this.setState({articleCount:this.props.articleCount}, this.fillGaps(this.state.currentArticleIndex));
            } else {
                this.setState({articleCount:1, currentArticleIndex: 0});
            }
            return;
        }

        if (this.state.verb === GET) {
            xhr.get({
                url: this.state.fetchCountUrl,
                data: this.state.urlParams
            }).then((result) => {
                this.setState({articleCount:result.body}, this.fillGaps(this.state.currentArticleIndex))
            }).catch((err) => {
                utils.logError(err);
            })
        } else {
            xhr.post({
                url: this.state.fetchCountUrl,
                data: this.state.urlParams
            }).then((result) => {
                this.setState({articleCount:result.body}, this.fillGaps(this.state.currentArticleIndex))
            }).catch((err) => {
                utils.logError(err);
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        if ((this.props.articleId !== nextProps.articleId) || (this.props.articleIndex !== nextProps.articleIndex)) {
            this.changeArticleId(nextProps.articleId, nextProps.articleIndex)
        }
    }

    fillGaps(index) {
        let pageNo = parseInt(index / PAGE_SIZE, 10);
        if (this.state.verb === GET) {
            let fetchUrl = this.props.fetchUrl + "?pageSize=" + PAGE_SIZE + "&pageNumber=" + pageNo;
            let data = Object.assign({}, this.state.urlParams);
            data.pageSize = PAGE_SIZE;
            data.pageNumber = pageNo;
            xhr.get({
                url: fetchUrl,
                data: data
            }).then((result) => {
                if (this.props.embeddedResultList) {
                    this.processList(result.body[this.props.embeddedResultList], pageNo, PAGE_SIZE);
                } else {
                    this.processList(result.body, pageNo, PAGE_SIZE);
                }
            }).catch((err) => {
                utils.logError(err);
            });
        } else {
            let fetchUrl = this.props.fetchUrl + "?pageSize=" + PAGE_SIZE + "&pageNumber=" + pageNo;
            xhr.post({
                url: fetchUrl,
                data: this.state.urlParams
            }).then((result) => {
                if (this.props.embeddedResultList) {
                    this.processList(result.body[this.props.embeddedResultList], pageNo, PAGE_SIZE);
                } else {
                    this.processList(result.body, pageNo, PAGE_SIZE);
                }
            }).catch((err) => {
                utils.logError(err);
            });
        }
    }

    processList(list, pageNo, pageSize) {
        let newListByIndex = Object.assign({}, this.state.articleListByIndex);
        let newListById = Object.assign({}, this.state.articleListByArticleId);
        for (let i = 0 ; i < list.length ; i++) {
            newListByIndex[pageNo*pageSize + i] = list[i].articleId;
            newListById[list[i].articleId] = pageNo*pageSize + i;
        }

        let endReached = false;
        if (list.length === 0) {
            endReached = true;
        }
        let nextIndex = null;
        let previousIndex = null;
        let nextId = null;
        let previousId = null;
        if (this.state.currentArticleIndex > 0)
            if (newListByIndex.hasOwnProperty(this.state.currentArticleIndex - 1)) {
                previousIndex = this.state.currentArticleIndex - 1;
                previousId = newListByIndex[previousIndex];
            } else {
                if (!endReached)
                    this.fillGaps(this.state.currentArticleIndex - 1);
            }
        if (this.state.currentArticleIndex < (this.state.articleCount - 1))
            if (newListByIndex.hasOwnProperty(this.state.currentArticleIndex + 1)) {
                nextIndex = this.state.currentArticleIndex + 1;
                nextId = newListByIndex[nextIndex];
            } else {
                if (!endReached)
                    this.fillGaps(this.state.currentArticleIndex + 1);
            }

        this.setState({
            articleListByIndex: newListByIndex,
            articleListByArticleId: newListById,
            nextArticleId: nextId,
            previousArticleId: previousId,
            nextArticleIndex: nextIndex,
            previousArticleIndex: previousIndex
        });
    }

    moveToArticle(event) {
        let id = event.target.getAttribute('data-articleid');
        let index = parseInt(event.target.getAttribute('data-articleindex'), 10);

        if (id && index >= 0) {
            if (this.props.changeArticle) {
                this.props.changeArticle(id, index);
            } else {
                this.changeArticleId(id, index);
            }
        }
    };

    changeArticleId(articleId, articleIndex) {
        if (this.state.articleListByArticleId.hasOwnProperty(articleId)) {
            let nextIndex = null;
            let previousIndex = null;
            let nextId = null;
            let previousId = null;
            if (articleIndex > 0)
                if (this.state.articleListByIndex.hasOwnProperty(articleIndex - 1)) {
                    previousIndex = articleIndex - 1;
                    previousId = this.state.articleListByIndex[previousIndex];
                } else {
                    this.fillGaps(articleIndex - 1);
                }
            if (articleIndex < (this.state.articleCount - 1))
                if (this.state.articleListByIndex.hasOwnProperty(articleIndex + 1)) {
                    nextIndex = articleIndex + 1;
                    nextId = this.state.articleListByIndex[nextIndex];
                } else {
                    this.fillGaps(articleIndex + 1);
                }

            this.setState({
                currentArticleIndex: articleIndex,
                currentArticleId: articleId,
                nextArticleId: nextId,
                previousArticleId: previousId,
                nextArticleIndex: nextIndex,
                previousArticleIndex: previousIndex
            });
        }
    }

    render() {

        let previousButtonClasses = 'button-previous la-TriangleLeft';
        let nextButtonClasses = 'button-next la-TriangleRight';
        this.state.previousArticleIndex === null ? previousButtonClasses += ' disabled' : null;
        this.state.nextArticleIndex === null ? nextButtonClasses += ' disabled' : null;

        return (
            <div className="notranslate no-print article-navigation-box">

                <div className={previousButtonClasses}
                     data-articleid={this.state.previousArticleId}
                     data-articleindex={this.state.previousArticleIndex}
                     onClick={this.moveToArticle}>
                </div>

                <span className="counter">

                    {this.state.spinnerVisibility ?
                        <span className="spinner" ></span>
                        :
                        <span>
                            {/* + 1 because UI articles count starts at 1 not 0*/}
                            {this.state.currentArticleIndex + 1}
                            &nbsp;
                            <FormattedMessage id="Dashboard_Charts_UIText_dashboard.counter.of" />
                            &nbsp;{this.state.articleCount}&nbsp;
                            <FormattedMessage id="Dashboard_Charts_UIText_dashboard.articles" />
                        </span>
                    }

                </span>

                <div className={nextButtonClasses}
                     data-articleid={this.state.nextArticleId}
                     data-articleindex={this.state.nextArticleIndex}
                     onClick={this.moveToArticle}>
                </div>

            </div>
        );
    }

}

export default ArticleNavigationBox;


// WEBPACK FOOTER //
// ./src/scripts/reusable/ArticleNavigationBox/ArticleNavigationBox.jsx